import React, { useEffect, useRef, useState } from "react";
import { getLocale } from "umi";
import { ConfigProvider, TimePicker, TimePickerProps } from "tea-component";
import moment from "moment";

import './index.scss'

import en_US from './en_US.ts';
import zh_CN from 'tea-component/es/i18n/locale/zh_CN';

interface Props {
  defaultVal: string
  timeVal: string
  format: string
  onConfirm: (selectedTime: string) => void
}

export default (props: Props) => {
  const locale = getLocale();
  const { defaultVal, timeVal, onConfirm, format = 'HH:mm', ...resetProps } = props;
  const inputRef = useRef(null)
  const isEN = locale === 'en-US';
  const onOpenChange = (open: boolean) => {
    if (!open) {
      // 解决tea的TimePicker组件弹窗出现后，点击确认弹窗消失后，按alt键弹窗又展示的问题
      const confirmBtnDom = document.querySelectorAll('.dbd-realtime-anylysis-minutes-time-picker .tea-input')[0];
      confirmBtnDom?.blur()
    }
  }

  return (
    <ConfigProvider locale={isEN ? en_US : zh_CN}>
      <TimePicker
        ref={inputRef}
        format={format}
        defaultValue={moment(defaultVal, format)}
        value={moment(timeVal, format)}
        className={`dbd-minuets-time-picker ${!isEN ? 'dbd-minuets-time-picker-ch' : ''}`}
        overlayClassName='dbd-minuets-time-picker-overlay'
        // onInputValueChange={onInputValueChange}
        onOpenChange={onOpenChange}
        onChange={onConfirm}
        {...(resetProps || {})}
      />
    </ConfigProvider>
  );
};